import React from 'react';

// Must match HIGHLIGHT_OPEN / HIGHLIGHT_CLOSE in backend/routers/search.py.
const OPEN = '';
const CLOSE = '';

/**
 * Renders a search snippet with the matched terms marked.
 *
 * The snippet is raw document text, and OCR content is attacker-influenced —
 * anyone able to upload a PDF controls it. This deliberately builds React
 * elements by splitting on sentinel markers rather than using
 * dangerouslySetInnerHTML: React escapes every text node, so a document
 * containing "<img src=x onerror=...>" renders as those characters instead of
 * executing. Never reintroduce HTML parsing here.
 */
const HighlightedText = ({ text, className = '' }) => {
  if (!text) return null;

  // Splitting on the markers makes every odd-indexed segment a match: the
  // markers always alternate open/close, and a leading marker yields an empty
  // first segment that keeps the parity correct. Index parity is used rather
  // than a running flag so an empty segment cannot desynchronise it.
  const parts = String(text).split(new RegExp(`${OPEN}|${CLOSE}`));

  return (
    <span className={className}>
      {parts.map((part, i) => {
        if (!part) return null;
        return i % 2 === 1 ? (
          <mark key={i} className="bg-amber-100 text-slate-900 rounded-sm px-0.5">
            {part}
          </mark>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        );
      })}
    </span>
  );
};

export default HighlightedText;
